import req from "../../../services/psikotest/request";

class AssessmentParticipantPersonalitySession {
  async reset(id: number, subtest_name: string) {
    try {
      const res = await req.get("/api/psikotest_system/assessment_participant_personality_session/" + id + "/reset/" + subtest_name);
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  }
}

export default AssessmentParticipantPersonalitySession;
